export class Account {
    constructor() {
        this.cash = 0;
        this.deltaCash = 0;
        this.cashWeight = 0;
        this.positions = [];
    }
    getTotalValue(includeDelta = false) {
        let value = includeDelta ? this.cash + this.deltaCash : this.cash;
        this.positions.forEach(pos => {
            value += pos.getValue(includeDelta);
        });
        return value;
    }
    getTotalWeight() {
        let weight = this.cashWeight;
        this.positions.forEach(pos => {
            weight += pos.weight;
        });
        return weight;
    }
    getCashAllocation(includeDelta) {
        return (includeDelta ? this.cash + this.deltaCash : this.cash) / this.getTotalValue(includeDelta);
    }
    getAllocation(position, includeDelta) {
        if (this.positions.indexOf(position) < 0) {
            // error
        }
        return position.getValue(includeDelta) / this.getTotalValue(includeDelta);
    }
    getTargetAllocation(position) {
        if (this.positions.indexOf(position) < 0) {
            // error
        }
        return position.weight / this.getTotalWeight();
    }
    getScore() {
        let subScore = 0;
        subScore += this.getCashSubScore();
        this.positions.forEach(pos => {
            subScore += this.getSubScore(pos);
        });
        return Math.sqrt(subScore);
    }
    balance(buyOnly = false) {
        let lastScore;
        this.resetDeltas();
        if (!buyOnly) {
            for (let position of this.positions) {
                const idealQuantity = Math.floor(((position.weight / this.getTotalWeight()) * this.getTotalValue()) / position.price);
                position.deltaQuantity = idealQuantity - position.quantity;
                this.deltaCash -= position.deltaQuantity * position.price;
            }
        }
        do {
            lastScore = this.getScore();
            const choices = [];
            for (let position of this.positions.concat().sort((a, b) => (a.price > b.price) ? -1 : 1)) {
                const originalDeltaQuantity = position.deltaQuantity;
                const originalDeltaCash = this.deltaCash;
                if ((this.cash + this.deltaCash) >= position.price) {
                    position.deltaQuantity = originalDeltaQuantity + 1;
                    this.deltaCash = originalDeltaCash - position.price;
                    if (this.getScore() < lastScore) {
                        continue;
                    }
                    position.deltaQuantity = originalDeltaQuantity;
                    this.deltaCash = originalDeltaCash;
                }
                if ((position.quantity + position.deltaQuantity) > 0 && (!buyOnly || (position.quantity + position.deltaQuantity) > position.quantity)) {
                    position.deltaQuantity = originalDeltaQuantity - 1;
                    this.deltaCash = originalDeltaCash + position.price;
                    if (this.getScore() < lastScore) {
                        continue;
                    }
                    position.deltaQuantity = originalDeltaQuantity;
                    this.deltaCash = originalDeltaCash;
                }
            }
        } while (this.getScore() < lastScore);
    }
    getCashSubScore() {
        const plannedAllocation = (this.cash + this.deltaCash) / this.getTotalValue(true);
        const targetAllocation = this.cashWeight / this.getTotalWeight();
        const result = Math.pow(targetAllocation - plannedAllocation, 2);
        return result;
    }
    getSubScore(position) {
        const plannedAllocation = position.getValue(true) / this.getTotalValue(true);
        const targetAllocation = position.weight / this.getTotalWeight();
        const result = Math.pow(targetAllocation - plannedAllocation, 2);
        return result;
    }
    resetDeltas() {
        this.deltaCash = 0;
        this.positions.forEach(pos => {
            pos.deltaQuantity = 0;
        });
    }
}
